export default {
    apiKey: "AIzaSyBOalWvMzUlY03jnN9AAJCOB3Z64szBalM",
    authDomain: "alba-demolition.firebaseapp.com",
    databaseURL: "https://alba-demolition.firebaseio.com",
    projectId: "alba-demolition",
    storageBucket: "alba-demolition.appspot.com",
    messagingSenderId: "223743046563",
    appId: "1:223743046563:web:fe0adacf593bb58d856016",
    measurementId: "G-F9N389V43N"
}